import state from "../store/state";

const userHasScope = (scope) => {
  const user = state.user;
  const isSuperUser = user.SUPERUSER;

  // if (isSuperUser) {
  //   return true;
  // }

  return user.scope.includes(scope);
};

export default userHasScope;
